<template>
    <div
         :style="`
         display:inline;
         width:100%;
         height:${d.height}px;
         background-color: ${active?'beige':'transparent'};`">
    </div>
</template>

<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['d','active'],
    components: {},
    name: "Spacer",
    data() {
      return {}
    },
    computed:{
      ...mapState(['icons','org'])
    }
  }
</script>


<style scoped>

</style>